// extracted by mini-css-extract-plugin
module.exports = {"section":"N_section__rRwh1"};